<template>
  <component
    v-if="name && dataReady"
    :is="name"
    :kaPos="kaPos"
    :tips="tips"
    :creativeData="creativeData"
  />
</template>

<script>
import { getUrlParam } from '@utils/url';
import InteractionIcon from './activities/InteractionIcon.vue';
import creativeService from '@services/creative';
import { POS_MAP } from '@data/posMap';
import {cheka, CHEKA_EVENTS} from '@utils/cheka';
import '@styles/index';

export default {
  name: 'KaActivities',
  components: {
    [InteractionIcon.name]: InteractionIcon
  },
  data() {
    const kaPos = getUrlParam('ka_pos');
    const pos = POS_MAP[kaPos] && POS_MAP[kaPos].name || '';
    const tips = POS_MAP[kaPos] && POS_MAP[kaPos].tips || '';
    return {
      kaPos,
      tips,
      name: pos,
      creativeData: {},
      dataReady: false,
    }
  },
  created() {
    this.getCreativeData();
    cheka('send', {eventid: CHEKA_EVENTS.PAGE_INIT.id});
  },
  methods: {
    getCreativeData() {
      creativeService.fetchCreative(POS_MAP[this.kaPos].info, POS_MAP[this.kaPos].prefix)
        .then(res => {
          if (res && res.data) {
            this.creativeData = res.data;
            this.dataReady = true;
            document.title = res.data.title || '';
          }
        })
    }
  }
}
</script>
